var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAddimage = function SvgAddimage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    viewBox: "0 0 350 350",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1219",
    "data-name": "Group 1219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3597",
    "data-name": "Path 3597",
    d: "M321.45,262.76H294.08V235.38a10,10,0,1,0-19.91,0v27.38H246.79a10,10,0,1,0,0,19.91h27.38V310a10,10,0,1,0,19.91,0V282.67h27.37a10,10,0,1,0,0-19.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3598",
    "data-name": "Path 3598",
    d: "M289.44,30H60.56a52.08,52.08,0,0,0-52,52V264.08a52.08,52.08,0,0,0,52,52H184.1a13,13,0,0,0,10.29-21s-4.48-5.12-9.8-5.12H157.54l.06.07h-97c-.62,0-1.23,0-1.83-.07H57.26v-.15a26,26,0,0,1-22.71-25.79V82a26,26,0,0,1,26-26H289.44a26,26,0,0,1,26,26v.75h0V209.09h0v16.63a13,13,0,0,0,26,0V82A52.08,52.08,0,0,0,289.44,30Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1218",
    "data-name": "Group 1218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3599",
    "data-name": "Path 3599",
    d: "M231.3,93.35H113.14a30.33,30.33,0,0,0-30.3,30.29v93.8a30.33,30.33,0,0,0,30.3,30.3H231.3a30.33,30.33,0,0,0,30.3-30.3v-93.8A30.32,30.32,0,0,0,231.3,93.35Zm10,124.09a10,10,0,0,1-10,10H113.14a9.69,9.69,0,0,1-2.78-.41l28.17-30.51,12.68,13.1a10.16,10.16,0,0,0,14.36.24c.23-.23.45-.46.66-.71l46.88-54.87,28.18,33.51Zm0-61.23L221,132a10.13,10.13,0,0,0-7.73-3.62h0a10.15,10.15,0,0,0-7.72,3.56L158,187.45l-12.38-12.79a10.16,10.16,0,0,0-14.36-.24l-.41.41-27.74,30V123.64a10,10,0,0,1,10-10H231.3a10,10,0,0,1,10,10Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 143.27,
    cy: 141.6,
    r: 10.16
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddimage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/addimage.31fcf989.svg";
export { ForwardRef as ReactComponent };